/*
 * JUB-153: model-number fragments in the predictive search drawer.
 *
 * Product titles glue the brand to the model ("DSEG7400", "DSE7320"), and
 * Shopify's predictive search only matches from the start of a word. So
 * "dseg7" finds DSEG7400, but "g7" or "732" find nothing until the whole
 * model number is typed (and then only via an exact tag match).
 *
 * This wraps fetch for the drawer's /search/suggest request only. When the
 * query looks like a bare model fragment and returns no results, it retries
 * once with "dse" prefixed and returns that response instead. Any query that
 * already returns results is left untouched.
 *
 * Maintained by Codo Digital. Remove this file and its <script> tag in
 * layout/theme.liquid to revert.
 */
(function () {
  'use strict';

  var MODEL_FRAGMENT = /^[a-z]{0,2}\d[a-z0-9\-\/]*$/i;
  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function' || window.__jub153ModelSearch) return;
  window.__jub153ModelSearch = true;

  function rewriteUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) return null;
      if (!/\/search\/suggest\/?$/.test(parsed.pathname)) return null;
      if (!parsed.searchParams.get('section_id')) return null;

      var query = (parsed.searchParams.get('q') || '').trim();
      if (!MODEL_FRAGMENT.test(query) || /^dse/i.test(query)) return null;

      parsed.searchParams.set('q', 'dse' + query);
      return parsed.toString();
    } catch (e) {
      return null;
    }
  }

  function hasResults(html) {
    return html.indexOf('predictive-search-result') !== -1;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var retryUrl = rewriteUrl(url);
    var request = originalFetch.apply(this, arguments);
    if (!retryUrl) return request;

    return request.then(function (response) {
      if (!response.ok) return response;
      return response.clone().text().then(function (html) {
        if (hasResults(html)) return response;
        return originalFetch(retryUrl, init).then(function (retry) {
          if (!retry.ok) return response;
          return retry.clone().text().then(function (retryHtml) {
            return hasResults(retryHtml) ? retry : response;
          });
        }).catch(function () {
          return response;
        });
      });
    });
  };
})();
